function Campaign(props) {
  return <h1>Campaign</h1>;
}

export default Campaign;
